import type { Theme } from '@mui/material/styles';

import type { ComponentOverrides } from 'theme/theme.types';

const headingColor = ({ theme }: { theme: Theme }) => ({
  color: theme.palette.heading.primary,
});

export const MuiTypography: ComponentOverrides['MuiTypography'] = {
  styleOverrides: {
    h1: headingColor,
    h2: headingColor,
    h3: headingColor,
    h4: headingColor,
    h5: headingColor,
    h6: headingColor,
  },
};
